import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';

const OverviewChartSideMenuScala = ({maxValue, unitsRenderer}) => (
  <div className="OverviewChart__sideMenu__marks">
    <div>{unitsRenderer(maxValue, maxValue)}</div>
    <div>{unitsRenderer(maxValue * 0.75, maxValue)}</div>
    <div>{unitsRenderer(maxValue * 0.5, maxValue)}</div>
    <div>{unitsRenderer(maxValue * 0.25, maxValue)}</div>
    <div>{unitsRenderer(0, maxValue)}</div>
  </div>
);

const ChartSideMenuTotalCell = ({firstDate, maxValue}) => {
  const dataTip = JSON.stringify({
    label: 'Total',
    date: firstDate && firstDate.format('DD/MM/YYYY'),
    totalRooms: maxValue
  });

  return (
    <div
      data-tip={dataTip}
      data-for="ChartSideMenu__tooltip"
      className="OverviewChart__sideMenu__table__row OverviewChart__sideMenu__table__row--with-shadow colab-centered-h">
      <div className="OverviewChart__sideMenu__table__row__title colab-bold">
        Total
      </div>
      <div className="OverviewChart__sideMenu__table__row__roomCount">
        {maxValue} rooms
      </div>
    </div>
  );
};

class ChartSideMenuHeaderCell extends React.Component<any> {
  render() {
    const {
      group,
      toggleNestedGroup,
      openedNestedGroups,
      firstDate
    } = this.props;
    const dataTip = JSON.stringify({
      label: group.label,
      date: firstDate && firstDate.format('DD/MM/YYYY'),
      totalRooms: group.totalRooms
    });

    return (
      <React.Fragment>
        <div
          data-tip={dataTip}
          data-for="ChartSideMenu__tooltip"
          className={classNames(
            'OverviewChart__sideMenu__table__row OverviewChart__sideMenu__table__row--with-shadow colab-centered-h',
            {'colab-clickable': !_.isEmpty(group.nestedElements)}
          )}
          onClick={() => toggleNestedGroup(group.value)}>
          <div className="OverviewChart__sideMenu__table__row__title colab-bold">
            {group.label}
          </div>
          {group.totalRooms && (
            <div className="OverviewChart__sideMenu__table__row__roomCount">
              {_.round(group.totalRooms)} rooms
            </div>
          )}
        </div>
        {_.find(openedNestedGroups, x => x === group.value) && (
          <div className="OverviewChart__sideMenu__table__stacked-rows">
            {group.nestedElements &&
              group.nestedElements.map(nestedElement => (
                <ChartSideMenuCell
                  key={nestedElement.value}
                  nestedElement={nestedElement}
                  firstDate={firstDate}
                />
              ))}
          </div>
        )}
      </React.Fragment>
    );
  }
}

class ChartSideMenuCell extends React.Component<any> {
  render() {
    const {nestedElement: {label, totalRooms}, firstDate} = this.props;

    const dataTip = JSON.stringify({
      label: label,
      date: firstDate && firstDate.format('DD/MM/YYYY'),
      totalRooms: totalRooms
    });

    return (
      <div
        className="OverviewChart__sideMenu__table__row colab-centered-h"
        data-tip={dataTip}
        data-for="ChartSideMenu__tooltip">
        <div className="OverviewChart__sideMenu__table__row__title colab-bold">
          {label}
        </div>
        {totalRooms && (
          <div className="OverviewChart__sideMenu__table__row__roomCount">
            {_.round(totalRooms)} rooms
          </div>
        )}
      </div>
    );
  }
}

const OverviewChartSideMenu = ({
  tableHeaderData,
  toggleNestedGroup,
  openedNestedGroups,
  unitsRenderer,
  totalRooms,
  firstDate
}) => (
  <div className="OverviewChart__sideMenu">
    <OverviewChartSideMenuScala
      unitsRenderer={unitsRenderer}
      maxValue={totalRooms}
    />
    <div className="OverviewChart__sideMenu__table">
      <ChartSideMenuTotalCell firstDate={firstDate} maxValue={totalRooms} />
      {tableHeaderData.map(group => (
        <ChartSideMenuHeaderCell
          key={group.value}
          group={group}
          firstDate={firstDate}
          toggleNestedGroup={toggleNestedGroup}
          openedNestedGroups={openedNestedGroups}
        />
      ))}
    </div>
  </div>
);

export default OverviewChartSideMenu;
